import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class LeagueKind extends Cloneable {
    static NONE = new LeagueKind(0, "NONE");

    static _values = [
        this.NONE,
        new LeagueKind(1, "LEAGUE_1"),
        new LeagueKind(2, "LEAGUE_2"),
        new LeagueKind(3, "LEAGUE_3"),
        new LeagueKind(4, "LEAGUE_4"),
        new LeagueKind(5, "LEAGUE_5"),
        new LeagueKind(6, "LEAGUE_6"),
        new LeagueKind(7, "LEAGUE_7")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, LeagueKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof LeagueKind) {
            return LeagueKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return LeagueKind.NONE.equal(value);
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof LeagueKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LeagueKind());
        } else if (target instanceof LeagueKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(LeagueKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});